import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  TextField,
  styled,
} from "@mui/material";
import CloseIconButton from "fe-common/ui/icons/closeIconButton";
import DialogContent from "@mui/material/DialogContent";
import { PatientInfoReportData } from "../patientVisitData";

//region [[ Styles ]]

const AddTableDataDialogView = styled(Dialog)({
  "& .MuiDialog-paper": {
    position: "relative",
  },
});

const Field = styled(TextField)({
  margin: "10px",
});

const CloseButton = styled(CloseIconButton)({
  "&.close-button": {
    left: "auto",
    right: "10px",
    width: "44px",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface AddTableDataDialogProps {
  schema: Record<string, any>;
  onSubmit: (newVal: PatientInfoReportData) => void;
  open: boolean;
  onClose: () => void;
  itemToEdit?: Record<string, any>;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AddTableDataDialog = ({
  schema,
  itemToEdit,
  ...props
}: AddTableDataDialogProps) => {
  const [tempData, setTempData] = useState({});

  const init = useCallback(
    (schema) =>
      setTempData(
        Object.keys(schema).reduce((acc, key) => ({ ...acc, [key]: null }), {}),
      ),
    [setTempData],
  );

  useEffect(() => {
    setTempData({ ...(itemToEdit || {}) });
  }, [itemToEdit]);

  useEffect(() => {
    init(schema);
  }, [schema, init]);

  const fieldValueChangedHandler = (key) => (e) => {
    const val = e?.target?.value;
    // if (!val) return;
    setTempData((oldData) => ({ ...oldData, [key]: val }));
  };

  const submit = () => {
    props.onSubmit(tempData as PatientInfoReportData);
    init(schema);
    props.onClose();
  };

  return (
    <AddTableDataDialogView open={props.open} onClose={props.onClose} fullWidth>
      <CloseButton onClick={props.onClose} />
      <DialogContent>
        {Object.entries(tempData).map(([key, value]) => (
          <Field
            key={key}
            value={value || ""}
            onChange={fieldValueChangedHandler(key)}
            variant="outlined"
            label={key}
            id={key}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant={"contained"} color={"primary"} onClick={submit}>
          {itemToEdit ? "Save" : "Add"}
        </Button>
        <Button variant={"outlined"} onClick={() => props.onClose()}>
          Cancel
        </Button>
      </DialogActions>
    </AddTableDataDialogView>
  );
};
